import { render, staticRenderFns } from "./vNutritionLabel.vue?vue&type=template&id=11824af4&scoped=true"
import script from "./vNutritionLabel.vue?vue&type=script&lang=ts"
export * from "./vNutritionLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11824af4",
  null
  
)

export default component.exports